import React from "react";
import "../../Styles/certified/abs.css";

export default function Abs() {
  return (
    <>
      <div className="abs-certified-details-section">
        <div className="abs-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="abs-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="abs-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="abs-certified-badge"
            />
            <div className="abs-certified-company-names">
              <a href="https://abshrms.in" target="_blank" rel="noopener noreferrer">
                <img src="/assets/abs/ABSHrms.png" alt="ABS HRMS Logo" className="abs-certified-company-logo" />
              </a>
              <h1 className="abs-certified-full-name">
                Ardens Business Solutions Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="abs-certified-details-right">
            <img
              src="/assets/abs/abs3.jpeg"
              alt="ABS HRMS Office"
              className="abs-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="abs-certified-description">
          <h2>
            Why Ardens Business Solutions Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            ABShrms is a complete, compliance-driven Human Resource Management System designed to simplify payroll, HR operations, statutory compliance, and workforce management for growing businesses across India. 
            Built with deep domain expertise and real-world industry experience, ABShrms helps organizations stay compliant, automate processes, and focus on what truly matters—people and growth. <br /> <br />
            Backed by over 16 years of hands-on experience in payroll, labor law compliance, and HR operations, our team understands the practical challenges faced by HR, finance, and management teams.
            This expertise is embedded into every module of ABShrms to ensure accuracy, reliability, and audit-ready compliance.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="abs-certified-info-cards">
          <div className="abs-certified-info-card">
            <div className="abs-certified-info-title">COMPANY SIZE</div>
            <div className="abs-certified-info-value">32 Employees</div>
          </div>
          <div className="abs-certified-info-card">
            <div className="abs-certified-info-title">INDUSTRY</div>
            <div className="abs-certified-info-value">HR Software</div>
          </div>
          <div className="abs-certified-info-card">
            <div className="abs-certified-info-title">CONNECT</div>
            <div className="abs-certified-info-icons">
              <span className="abs-certified-icon-round">
                <a href="https://abshrms.in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="abs-certified-icon-round">
                <a href="https://in.linkedin.com/company/abshrms" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="abs-certified-icon-round">
                <a href="https://www.facebook.com/ArdensHR" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="abs-certified-icon-round">
                <a href="https://www.instagram.com/ardenshr" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
            </div>
          </div>
          <div className="abs-certified-info-card">
            <div className="abs-certified-info-title">LOCATION (HQ)</div>
            <div className="abs-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="abs-certified-recognition-section">
          <h2 className="abs-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="abs-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="abs-certified-recognition-image"
            />
          </div>
          <div className="abs-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at ABS Section */}
        <div className="abs-certified-life-section">
          <h2 className="abs-certified-life-title">
            Life at Ardens Business Solutions Private Limited
          </h2>
          <div className="abs-certified-life-gallery">
            <div className="abs-certified-life-col">
              <img src="/assets/abs/abs2.jpeg" alt="Office 1" className="abs-certified-life-img" />
              <img src="/assets/abs/abs4.jpeg" alt="Meeting 1" className="abs-certified-life-img" />
            </div>
            <div className="abs-certified-life-col abs-certified-life-center">
              <img src="/assets/abs/abs5.jpeg" alt="Main Office" className="abs-certified-life-img abs-certified-life-img-large" />
            </div>
            <div className="abs-certified-life-col">
              <img src="/assets/abs/abs6.jpeg" alt="Office 2" className="abs-certified-life-img" />
              <img src="/assets/abs/abs7.jpeg" alt="Meeting 2" className="abs-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}